import { useAppSelector } from './redux';

/**
 * Checks if the `userId` you pass matches the id
 * of the current user.
 */
export const useIsCurrentUser = (userId?: string): boolean => {
    const currentUserId = useAppSelector((state) => state.user?.userAccount?.user.id);
    if (currentUserId == null || userId == null) return false;
    return currentUserId === userId;
};
